







import Vue, { PropType } from 'vue'
import { WidgetSettingsCheckboxList } from '../widgets/base/widget/WidgetInterface'
import SettingsPanelCustomCheckbox from './SettingsPanelCustomCheckbox.vue'

export default Vue.extend({
  components: {
    SettingsPanelCustomCheckbox
  },
  props: {
    setting: {
      type: Object as PropType<WidgetSettingsCheckboxList>,
      required: true,
      default: {}
    }
  },
  methods: {
    onUpdateCheckbox(cboxListIndex: number, isChecked: boolean) {
      const list = this.setting.list ? JSON.parse(JSON.stringify(this.setting.list)) : {}
      list[cboxListIndex].checked = isChecked
      this.$emit('input', list)
    }
  }
})
